import $ from 'jquery';

export const toggleSubMenu = () => {
    $(document).on('click', '.toggle-sub-menu', function () {
        const toggledDivId = $(this).data('toggled');
        const toggledDiv = $(toggledDivId);
        const transitionDuration = 250;

        if (toggledDiv.length === 0) {
            return;
        }

        const arrowBtn = $(this).find('.btn-as-arrow');

        if (arrowBtn.length > 0) {
            if (toggledDiv.is(':hidden')) {
                arrowBtn.removeClass('btn-as-arrow--up');
            } else {
                arrowBtn.addClass('btn-as-arrow--up');
            }
        }

        toggledDiv.stop().slideToggle(transitionDuration);
    });
};
